import { render, staticRenderFns } from "./NewFormOfClasses.vue?vue&type=template&id=1a22c95c&scoped=true&"
import script from "./NewFormOfClasses.vue?vue&type=script&lang=js&"
export * from "./NewFormOfClasses.vue?vue&type=script&lang=js&"
import style0 from "./NewFormOfClasses.vue?vue&type=style&index=0&id=1a22c95c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22c95c",
  null
  
)

export default component.exports